import { TfiFacebook } from "react-icons/tfi";
import { BiLogoInstagramAlt } from "react-icons/bi";
import { GrLinkedinOption } from "react-icons/gr";
import { useContext } from "react";
import CurrencyDropdown from "../../CurrencyDropdown";
import { CurrencyContext } from "../../../context/CurrencyContext";

const Footer = () => {
  const { currency, setCurrency } = useContext(CurrencyContext);

  return (
    <footer className="w-full bg-black bg-cover bg-center text-white py-8 lg:py-16 font-fira-sans">
      <div className="gutter-x mb-10 lg:mb-16">
        {/* Main Content Container */}
        <div className="border border-white/30 overflow-hidden">
          {/* Mobile Layout */}
          <div className="lg:hidden">
            {/* Mobile Logo Section */}
            <div className="flex flex-col items-center justify-center py-6 border-b border-white/30 h-[120px]">
              <img
                src="/outs.svg"
                alt="Outskill Logo"
                width="140"
                height="32"
                className="h-8 "
              />
            </div>

            {/* Mobile Newsletter Section */}
            <div className="p-6 border-b border-[#FFFFFF66]/30">
              <div className="text-center mb-4">
                <p className="text-[21px] font-medium mb-2">
                  Join our newsletter
                </p>
                <p className="text-sm text-gray-400 mb-4">
                  Keep up to date with everything Outskill
                </p>
              </div>
              <div className="w-full">
                <iframe
                  src="https://embeds.beehiiv.com/a086d7f5-5e02-4e85-ae52-9cda825501ed?slim=true"
                  title="Outskill newsletter signup"
                  data-test-id="beehiiv-embed"
                  height="52"
                  frameBorder="0"
                  scrolling="no"
                  style={{
                    margin: 0,
                    borderRadius: "0px",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                ></iframe>
              </div>
            </div>

            {/* Mobile Links Grid */}
            <div className="p-6 border-b border-[#FFFFFF66]/30">
              <div className="space-y-6">
                {/* Fellowships */}
                <div>
                  <h3 className="text-sm font-medium mb-3 text-white">
                    FELLOWSHIPS
                  </h3>
                  <div className="space-y-2">
                    <a
                      href="/6-month-ai-generalist-fellowship"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      AI Generalist Fellowship
                    </a>
                    <a
                      href="/6-month-ai-engineering"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      AI Engineering Fellowship
                    </a>
                  </div>
                </div>

                {/* Workshops */}
                <div>
                  <h3 className="text-sm font-semibold mb-3 text-white">
                    WORKSHOPS
                  </h3>
                  <div className="space-y-2">
                    <a
                      href="/2-day-ai-mastermind"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Gen-AI Mastermind
                    </a>
                    <a
                      href="/2-day-ai-engineering-mastermind"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Gen-AI Engineering Mastermind
                    </a>
                    <a
                      href="/3-day-generative-ai-bootcamp"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      3-Day Generative AI Bootcamp
                    </a>
                    <a
                      href="/ai-generalist-bootcamp"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Gen-AI Bootcamp
                    </a>
                  </div>
                </div>

                {/* Self-Paced */}
                <div>
                  <h3 className="text-sm font-semibold mb-3 text-white">
                    SELF-PACED
                  </h3>
                  <div className="space-y-2">
                    <a
                      href="/ai-accelerator"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      AI Accelerator
                    </a>
                    <a
                      href="/engineering-accelerator"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      AI Engineering Accelerator
                    </a>
                    <a
                      href="/ai-tools-deepdive"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      AI Tools Mastery
                    </a>
                  </div>
                </div>

                {/* Company */}
                <div>
                  <h3 className="text-sm font-semibold mb-3 text-white">
                    COMPANY
                  </h3>
                  <div className="space-y-2">
                    <a
                      href="/creator-partnerships"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Creator Partnerships
                    </a>
                    <a
                      href="/ai-generalist-review-alumni"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Alumni
                    </a>
                    <a
                      href="/terms-and-conditions"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Terms & Conditions
                    </a>
                    <a
                      href="/privacy-policy"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Privacy Policy
                    </a>
                    <a
                      href="/refund-policy"
                      className="block text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      Refund Policy
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Bottom Section */}
            <div className="flex flex-col items-center gap-2 font-fira-sans p-6">
              <div className="flex items-center gap-4">
                <a
                  href="https://www.facebook.com/outskillapp"
                  aria-label="Outskill on Facebook"
                  title="Outskill on Facebook"
                  className="bg-black/50 border border-white/20 p-2 rounded opacity-70 hover:opacity-100 hover:bg-white/10 hover:border-white/40 hover:scale-110 transition-all duration-200"
                >
                  <TfiFacebook size={20} className="" />
                </a>
                <a
                  href="https://www.instagram.com/outskillcom/"
                  aria-label="Outskill on Instagram"
                  title="Outskill on Instagram"
                  className="bg-black/50 border border-[#FFFFFF1A] p-2 rounded opacity-70 hover:opacity-100 hover:bg-white/10 hover:border-white/40 hover:scale-110 transition-all duration-200"
                >
                  <BiLogoInstagramAlt size={20} />
                </a>
                <a
                  href="https://www.linkedin.com/company/outskillcom/"
                  aria-label="Outskill on LinkedIn"
                  title="Outskill on LinkedIn"
                  className="bg-black/50 border border-[#FFFFFF1A] p-2 rounded opacity-70 hover:opacity-100 hover:bg-white/10 hover:border-white/40 hover:scale-110 transition-all duration-200"
                >
                  <GrLinkedinOption size={20} />
                </a>
              </div>
              <CurrencyDropdown
                currency={currency}
                onCurrencyChange={setCurrency}
                variant="dark"
              />
            </div>
          </div>

          {/* Desktop Layout */}
          <div className="hidden lg:flex">
            {/* Left Side - Logo + Social + Currency */}
            <div className="w-[30%] border-r border-white/30 flex flex-col">
              {/* Logo and Copyright */}
              <div className="flex-1 flex flex-col items-center justify-center p-8">
                <img
                  src="/outs.svg"
                  alt="Outskill Logo"
                  width="140"
                  height="32"
                  className="h-8 mb-4"
                />
                <p className="text-sm text-gray-400 text-center">
                  © 2026 Sisinty Pvt. Ltd. All rights reserved
                </p>
              </div>

              {/* Social Icons and Currency */}
              <div className=" flex items-center justify-around p-6">
                <div className="flex items-center justify-center gap-4 ">
                  <a
                    href="https://www.facebook.com/outskillapp"
                    aria-label="Outskill on Facebook"
                    title="Outskill on Facebook"
                    className="bg-black/50 border border-[#FFFFFF1A] p-2 rounded opacity-70 hover:opacity-100 transition-opacity"
                  >
                    <TfiFacebook size={20} />
                  </a>
                  <a
                    href="https://www.instagram.com/outskillcom/"
                    aria-label="Outskill on Instagram"
                    title="Outskill on Instagram"
                    className="bg-black/50 border border-[#FFFFFF1A] p-2 rounded opacity-70 hover:opacity-100 transition-opacity"
                  >
                    <BiLogoInstagramAlt size={20} />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/outskillcom/"
                    aria-label="Outskill on LinkedIn"
                    title="Outskill on LinkedIn"
                    className="bg-black/50 border border-[#FFFFFF1A] p-2 rounded opacity-70 hover:opacity-100 transition-opacity"
                  >
                    <GrLinkedinOption size={20} />
                  </a>
                </div>
                <div className="flex justify-center">
                  <CurrencyDropdown
                    currency={currency}
                    onCurrencyChange={setCurrency}
                    variant="dark"
                  />
                </div>
              </div>
            </div>

            {/* Right Side - Links + Newsletter */}
            <div className="w-[75%] flex flex-col">
              {/* Top Section - Links Grid */}
              <div className="border-b border-white/30 p-8">
                <div className="grid grid-cols-4 gap-8">
                  {/* Fellowships */}
                  <div>
                    <h3 className="text-sm font-medium mb-4 text-white">
                      FELLOWSHIPS
                    </h3>
                    <div className="space-y-3">
                      <a
                        href="/6-month-ai-generalist-fellowship"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        AI Generalist Fellowship
                      </a>
                      <a
                        href="/6-month-ai-engineering"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        AI Engineering Fellowship
                      </a>
                    </div>
                  </div>

                  {/* Workshops */}
                  <div>
                    <h3 className="text-sm font-medium mb-4 text-white">
                      WORKSHOPS
                    </h3>
                    <div className="space-y-3">
                      <a
                        href="/2-day-ai-mastermind"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Gen-AI Mastermind
                      </a>
                      <a
                        href="/2-day-ai-engineering-mastermind"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Gen-AI Engineering Mastermind
                      </a>
                      <a
                        href="/3-day-generative-ai-bootcamp"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        3-Day Generative AI Bootcamp
                      </a>
                      <a
                        href="/ai-generalist-bootcamp"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Gen-AI Bootcamp
                      </a>
                    </div>
                  </div>

                  {/* Self-Paced */}
                  <div>
                    <h3 className="text-sm font-medium mb-4 text-white">
                      SELF-PACED
                    </h3>
                    <div className="space-y-3">
                      <a
                        href="/ai-accelerator"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        AI Accelerator
                      </a>
                      <a
                        href="/engineering-accelerator"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        AI Engineering Accelerator
                      </a>
                      <a
                        href="/ai-tools-deepdive"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        AI Tools Mastery
                      </a>
                    </div>
                  </div>

                  {/* Company */}
                  <div>
                    <h3 className="text-sm font-medium mb-4 text-white">
                      COMPANY
                    </h3>
                    <div className="space-y-3">
                      <a
                        href="/creator-partnerships"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Creator Partnerships
                      </a>
                      <a
                        href="/ai-generalist-review-alumni"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Alumni
                      </a>
                      <a
                        href="/terms-and-conditions"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Terms & Conditions
                      </a>
                      <a
                        href="/privacy-policy"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Privacy Policy
                      </a>
                      <a
                        href="/refund-policy"
                        className="block text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        Refund Policy
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Section - Newsletter */}
              <div className="p-8 font-fira-sans">
                <div className="flex items-center gap-12">
                  <div className="w-[40%]">
                    <p className="text-lg font-medium mb-2">
                      Join our newsletter
                    </p>
                    <p className="text-sm text-gray-400">
                      Keep up to date with everything Outskill
                    </p>
                  </div>
                  <div className="w-[60%]">
                    <iframe
                      src="https://embeds.beehiiv.com/a086d7f5-5e02-4e85-ae52-9cda825501ed?slim=true"
                      title="Outskill newsletter signup"
                      data-test-id="beehiiv-embed"
                      height="52" 
                      frameBorder="0"
                      scrolling="no"
                      style={{
                        margin: 0,
                        borderRadius: "0px",
                        backgroundColor: "transparent",
                        width: "100%",
                      }}
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Copyright Section */}
        <p className="text-sm text-white text-center mt-6 block lg:hidden">
          © 2026 Sisinty Pvt. Ltd. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
